// 文件API封装
// 注意：使用前需在前端项目中安装axios: npm install axios
// 或使用其他HTTP客户端库替换axios

// 配置HTTP客户端
// 这里使用axios作为示例，你可以替换为fetch或其他HTTP客户端
import axios from 'axios';

// 创建axios实例
 

// 文件API接口
const fileApi = {
  /**
   * 上传文件
   * @param file 要上传的文件对象或arraybuffer
   * @param params 上传参数，包含base_id
   * @returns Promise
   */
  uploadFile: async (file, params) => {
    // 设置最大文件大小限制（100MB）
    const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
    
    // 检查文件大小
    let fileSize;
    if (file instanceof File) {
      fileSize = file.size;
    } else if (file instanceof ArrayBuffer) {
      fileSize = file.byteLength;
    } else if (file instanceof Blob) {
      fileSize = file.size;
    }
    
    if (fileSize > MAX_FILE_SIZE) {
      throw new Error(`文件大小超过限制，最大允许上传100MB，当前文件大小：${(fileSize / (1024 * 1024)).toFixed(2)}MB`);
    }
    
    let formData = new FormData();
    
    if (file instanceof File) {
      // 如果是File对象，直接使用
      formData.append('file', file);
    } else {
      // 如果是ArrayBuffer，转换为Blob再上传
      const blob = new Blob([file], { type: 'application/pdf' });
      const fileName = params?.fileName || 'document.pdf';
      formData.append('file', blob, fileName);
    }
    
    if (params?.directory) {
      formData.append('directory', params.directory);
    }

    if (params?.base_id) {
      formData.append('base_id', params.base_id);
    }

    // 报告类型：'1' = 国管局报告附件，不传/空 = 团体报告附件
    if (params?.report_type) {
      formData.append('report_type', params.report_type);
    }
    try{
      const response= await axios({
              method: "POST",
              url: "/file/upload",      
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data' // 正确设置Content-Type
              },
            })
      return response.data;
    }catch(error){
      console.error('上传文件失败:', error);
      throw error;
    }
    
  },

  /**
   * 下载文件
   * @param fileId 文件ID
   * @param base_id 基础ID
   * @returns Promise 文件Blob对象
   */
  downloadFile: async (fileId, base_id) => {
    const response = await axios({
      method: "GET",
      url: `/file/download/${fileId}`,
      params: {
        base_id: base_id
      },
      responseType: 'blob'
    });
    
    return response.data;
  },

  /**
   * 通过base_id下载文件（团体报告附件）
   * 仅返回团体类型（report_type 为空）中最新的一条
   * @param base_id 基础ID
   * @returns Promise 文件Blob对象
   */
  downloadByBaseID: async (base_id) => {
    const response = await axios({
      method: "GET",
      url: `/file/downloadByBaseID/${base_id}`,
      responseType: 'blob'
    });

    return response.data;
  },

  /**
   * 通过base_id下载国管局报告附件
   * 返回国管局类型（report_type=1）中最新的一条
   * @param base_id 基础ID
   * @returns Promise 文件Blob对象
   */
  downloadGuoGuanJuByBaseID: async (base_id) => {
    const response = await axios({
      method: "GET",
      url: `/file/download/base/guoguanju/${base_id}`,
      responseType: 'blob'
    });

    return response.data;
  },

};

export default fileApi;

// 使用示例
// import fileApi from './fileApi';

// // 上传文件示例
// const handleFileUpload = async (file: File) => {
//   try {
//     const response = await fileApi.uploadFile(file, { directory: 'test' });
//     console.log('上传成功:', response);
//   } catch (error) {
//     console.error('上传失败:', error);
//   }
// };

// // 下载文件示例
// const handleFileDownload = async (fileId: number, fileName: string, base_id: string) => {
//   try {
//     const blob = await fileApi.downloadFile(fileId, base_id);
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error('下载失败:', error);
//   }
// };

// // 通过base_id下载文件示例
// const handleDownloadByBaseID = async (base_id: string, fileName: string) => {
//   try {
//     const blob = await fileApi.DownloadFileByBaseID(base_id);
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error('通过base_id下载失败:', error);
//   }
// };

// // 获取文件信息示例
// const handleGetFileInfo = async (fileId: number) => {
//   try {
//     const fileInfo = await fileApi.getFileInfo(fileId);
//     console.log('文件信息:', fileInfo);
//   } catch (error) {
//     console.error('获取文件信息失败:', error);
//   }
// };